export const STANDARD = 'STANDARD';
export const CONTAINERHALL = 'CONTAINERHALL';
